import { LauncherElement } from '../../types/launcherElement';
import { getElementById } from './getElementById';

export const removeElement = (
  elements: LauncherElement[],
  id: string
): [LauncherElement[], LauncherElement | null] => {
  const [element, parent] = getElementById(elements, id);
  if (!element) return [elements, null];

  if (parent) {
    parent.props.children = parent.props.children?.filter(
      (child) => child.id !== id
    );
    return [elements, element];
  } else {
    const index = elements.findIndex((el) => el.id === id);
    const removedElement = elements.splice(index, 1)[0];
    return [elements, removedElement];
  }
};
